export default "__VITE_ASSET__CCxlrqGJ__"